// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/DSATabs.scss
// module id = 1264
// module chunks = 0